import { Link } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
import LanguageSwitcher from './LanguageSwitcher';

const Footer = () => {
  const year = new Date().getFullYear();
  const { t } = useLanguage();
  return (
    <footer className="bg-text-primary text-white px-6 md:px-12 lg:px-16 pt-16 pb-8" data-testid="site-footer">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 mb-12">
          <div className="col-span-2 md:col-span-1">
            <h3 className="font-heading text-2xl font-bold mb-3">Match My Cleaner</h3>
            <p className="text-sm text-gray-300 leading-relaxed">
              {t('footer.tagline', 'The trusted marketplace connecting customers with vetted, background-checked cleaners.')}
            </p>
            <div className="mt-4 inline-flex items-center gap-2 text-xs text-emerald-300">
              <ShieldCheck className="w-4 h-4" />
              {t('footer.trustBadge', 'All cleaners background-checked')}
            </div>
            <div className="mt-5">
              <LanguageSwitcher />
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-wider mb-4 text-gray-400">{t('footer.colPlatform', 'Platform')}</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="hover:text-emerald-300 transition" data-testid="footer-home">{t('footer.linkFind', 'Find a Cleaner')}</Link></li>
              <li><Link to="/auth" className="hover:text-emerald-300 transition" data-testid="footer-join">{t('footer.linkJoin', 'Become a Cleaner')}</Link></li>
              <li><Link to="/contact" className="hover:text-emerald-300 transition" data-testid="footer-contact">{t('footer.linkContact', 'Contact')}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-wider mb-4 text-gray-400">{t('footer.colTrust', 'Trust')}</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/trust-safety" className="hover:text-emerald-300 transition" data-testid="footer-trust">{t('footer.linkTrust', 'Trust & Safety')}</Link></li>
              <li><Link to="/refund-policy" className="hover:text-emerald-300 transition" data-testid="footer-refund">{t('footer.linkRefund', 'Refund Policy')}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-wider mb-4 text-gray-400">{t('footer.colLegal', 'Legal')}</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/privacy-policy" className="hover:text-emerald-300 transition" data-testid="footer-privacy">{t('footer.linkPrivacy', 'Privacy Policy')}</Link></li>
              <li><Link to="/terms-of-service" className="hover:text-emerald-300 transition" data-testid="footer-terms">{t('footer.linkTerms', 'Terms of Service')}</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-gray-400">
          <p>© {year} Match My Cleaner. {t('footer.rights', 'All rights reserved.')}</p>
          <p className="italic">{t('footer.kicker', 'Built with care for cleaners and customers alike.')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
